// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.movinSponsorBanner {
    background-color: #ba1e24;
    padding: 0px 0px 0px 0px;
    /* margin: 100px 0px; */
  }
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-150px * 7));
    }
  }
  .sponsor-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 10px;
  }
  
  .sponsor-heading {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
      text-align: center;
      margin: 0px;
    padding: 0px;
  }
  
  .slide-sponsor-track {
      display: flex;
      animation: scroll 40s linear infinite;
  }
  
  @keyframes scroll {
      0% {
          transform: translateX(0);
      }
      100% {
          transform: translateX(-50%);
      }
  }
  
  /* Ensure the container hides overflow */
  .sliderSponsorBanner {
      overflow: hidden;
  }
  .sliderSponsorBanner {
    background: white;
    height: 100px;
    margin: auto;
    overflow: hidden;
    position: relative;
    /* width: 960px; */
  }
  
  .sliderSponsorBanner::before,
  .sliderSponsorBanner::after {
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: 2;
  }
  
  .sliderSponsorBanner::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }
  
  .sliderSponsorBanner::before {
    left: 0;
    top: 0;
  }
  
  .sliderSponsorBanner .slide-sponsor-track {
    animation: scroll 12s linear infinite;
    display: flex;
    width: calc(150px * 14);
  }
  
  .sliderSponsorBanner .slide-sponsor {
    height: 100px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-sponsor > img {
    height: 40px;
    width: 200px;
    object-fit: contain;
  }
  .showBorderTop {
    border-top: 1px solid white;
  }
  @media screen and (max-width: 600px) {
    .slick-slide img {
      height: 20px !important;
    }
    .movingBanner {
      padding: 0px 0px;
      margin: 0px 0px;
    }
    .slide-sponsor > img {
      height: 50px !important;
    }
    .sliderSponsorBanner .slide {
      height: 90px;
      padding: 15px;
      width: 180px;
    }
    .sliderSponsorBanner::before,
    .sliderSponsorBanner::after {
      content: "";
      height: 90px;
      padding: 15px;
      position: absolute;
      width: 200px;
      z-index: 2;
    }
    .sliderSponsorBanner {
      height: 90px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/homepage/sponsor/mobileSponsor.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,uCAAuC;IACzC;EACF;EACA;MACI,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,cAAc;EAClB;;EAEA;MACI,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;IACb,YAAY;EACd;;EAEA;MACI,aAAa;MACb,qCAAqC;EACzC;;EAEA;MACI;UACI,wBAAwB;MAC5B;MACA;UACI,2BAA2B;MAC/B;EACJ;;EAEA,wCAAwC;EACxC;MACI,gBAAgB;EACpB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,MAAM;IACN,0BAA0B;EAC5B;;EAEA;IACE,OAAO;IACP,MAAM;EACR;;EAEA;IACE,qCAAqC;IACrC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,gBAAgB;MAChB,eAAe;IACjB;IACA;MACE,uBAAuB;IACzB;IACA;MACE,YAAY;MACZ,aAAa;MACb,YAAY;IACd;IACA;;MAEE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,UAAU;IACZ;IACA;MACE,YAAY;IACd;EACF","sourcesContent":[".movinSponsorBanner {\n    background-color: #ba1e24;\n    padding: 0px 0px 0px 0px;\n    /* margin: 100px 0px; */\n  }\n  @keyframes scroll {\n    0% {\n      transform: translateX(0);\n    }\n    100% {\n      transform: translateX(calc(-150px * 7));\n    }\n  }\n  .sponsor-item {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin: 0 10px;\n  }\n  \n  .sponsor-heading {\n      font-size: 14px;\n      font-weight: bold;\n      margin-bottom: 5px;\n      text-align: center;\n      margin: 0px;\n    padding: 0px;\n  }\n  \n  .slide-sponsor-track {\n      display: flex;\n      animation: scroll 40s linear infinite;\n  }\n  \n  @keyframes scroll {\n      0% {\n          transform: translateX(0);\n      }\n      100% {\n          transform: translateX(-50%);\n      }\n  }\n  \n  /* Ensure the container hides overflow */\n  .sliderSponsorBanner {\n      overflow: hidden;\n  }\n  .sliderSponsorBanner {\n    background: white;\n    height: 100px;\n    margin: auto;\n    overflow: hidden;\n    position: relative;\n    /* width: 960px; */\n  }\n  \n  .sliderSponsorBanner::before,\n  .sliderSponsorBanner::after {\n    content: \"\";\n    height: 100px;\n    position: absolute;\n    width: 200px;\n    z-index: 2;\n  }\n  \n  .sliderSponsorBanner::after {\n    right: 0;\n    top: 0;\n    transform: rotateZ(180deg);\n  }\n  \n  .sliderSponsorBanner::before {\n    left: 0;\n    top: 0;\n  }\n  \n  .sliderSponsorBanner .slide-sponsor-track {\n    animation: scroll 12s linear infinite;\n    display: flex;\n    width: calc(150px * 14);\n  }\n  \n  .sliderSponsorBanner .slide-sponsor {\n    height: 100px;\n    width: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .slide-sponsor > img {\n    height: 40px;\n    width: 200px;\n    object-fit: contain;\n  }\n  .showBorderTop {\n    border-top: 1px solid white;\n  }\n  @media screen and (max-width: 600px) {\n    .slick-slide img {\n      height: 20px !important;\n    }\n    .movingBanner {\n      padding: 0px 0px;\n      margin: 0px 0px;\n    }\n    .slide-sponsor > img {\n      height: 50px !important;\n    }\n    .sliderSponsorBanner .slide {\n      height: 90px;\n      padding: 15px;\n      width: 180px;\n    }\n    .sliderSponsorBanner::before,\n    .sliderSponsorBanner::after {\n      content: \"\";\n      height: 90px;\n      padding: 15px;\n      position: absolute;\n      width: 200px;\n      z-index: 2;\n    }\n    .sliderSponsorBanner {\n      height: 90px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
